<template>
  <div class="LogroutingSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
            @on-change="changeCompanyID"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyIdList"
              :key="item.id"
            >{{ item.companyName }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="6">
        <Input
          v-model="accountName"
          :placeholder="$t('RAM.common.filterByAccountName')"
          @on-search="searchAccountName()"
        />
      </Col>
      <Col span="6">
        <Input
          v-model="logroutingName"
          :placeholder="$t('alarms.common.filterByLoggingRouteName')"
          @on-search="searchLogroutingName()"
        />
      </Col>
      <Col span="4">
        <Button
                    type="primary"
                    v-hasPermission="['resourceConfigurationManagement:gcp:log:logrouting:page']"
                    @click="getData"
                    >{{ $t("message.select") }}</Button>
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../../utils/cookieUtil";
import TableLogrouting from "./TableLogrouting";
var tableLogrouting = TableLogrouting;
export default {
  name: "LogroutingSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyIdList: [],
      accountName: "",
      logroutingName: "",
    };
  },
  mounted: function () {
    if (this.company == 1) {
      this.listRegisterInformation();
    } else {
      // tableLogrouting.methods.showAll();
    }
  },
  methods: {
    getData(){
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("logroutingName", this.logroutingName);
      tableLogrouting.methods.showAll();
    },
    //查询公司
    listRegisterInformation: function () {
      this.$api.user.listRegisterInformation().then((res) => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
        if (this.companyIdList) {
          this.companyId = this.companyIdList[0].id;
        }
        this.searchCompany();
      });
    },
    // 切换公司
    changeCompanyID: function () {
      this.searchCompany();
    },
    // 按公司搜索
    searchCompany: function () {
      eventBus.$emit("companyId", this.companyId);
      // tableLogrouting.methods.showAll();
    },
    // 按账户名称查询
    searchAccountName: function () {
      eventBus.$emit("accountName", this.accountName);
      // tableLogrouting.methods.showAll();
    },
    //按资源名称来查询
    searchLogroutingName: function () {
      eventBus.$emit("logroutingName", this.logroutingName);
      // tableLogrouting.methods.showAll();
    },
  },
};
</script>
<style scoped>
.LogroutingSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/gcp/cloudLogging/log/LogroutingSearch.vue